import { render, staticRenderFns } from "./index.vue?vue&type=template&id=39f1b9a6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=39f1b9a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f1b9a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39f1b9a6')) {
      api.createRecord('39f1b9a6', component.options)
    } else {
      api.reload('39f1b9a6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=39f1b9a6&scoped=true&", function () {
      api.rerender('39f1b9a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Content/index.vue"
export default component.exports